import { render, staticRenderFns } from "./HbUnitIcon.vue?vue&type=template&id=5cddf2fc&scoped=true&"
import script from "./HbUnitIcon.vue?vue&type=script&lang=js&"
export * from "./HbUnitIcon.vue?vue&type=script&lang=js&"
import style0 from "./HbUnitIcon.vue?vue&type=style&index=0&id=5cddf2fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cddf2fc",
  null
  
)

export default component.exports